import { useOpenSearchContext } from './useOpenSearchContext';

const useHits = <T>() => {
  const { hits, totalHits } = useOpenSearchContext();

  const hitsData = hits?.map(
    ({ _source, inner_hits }) =>
      ({
        ..._source,
        siblings: inner_hits?.siblings?.hits?.hits?.map(
          sibling => sibling._source,
        ),
      } as T),
  );

  return {
    hits: hitsData,
    totalHits,
  };
};

export { useHits };
